import type { Template, TemplateAr } from '../../template-data';

import { automateSupportTicketsQualityAssuranceAr } from './automate-support-tickets-quality-assurance';
import { automateUpSellsFromSupportTicketsAr } from './automate-up-sells-from-support-tickets';
import { automateCartRecoveryAr } from './automate-cart-recovery';
import { automateZendeskCustomFieldsFillUpAr } from './automate-zendesk-custom-fields-fill-up';
import { automateHubspotCustomFieldsFillUpAr } from './automate-hubspot-custom-fields-fill-up';
import { automateSalesforceCustomFieldsFillUpAr } from './automate-salesforce-custom-fields-fill-up';
import { automateIntercomCustomFieldsFillUpAr } from './automate-intercom-custom-fields-fill-up';
import { automateFreshdeskCustomFieldsFillUpAr } from './automate-freshdesk-custom-fields-fill-up';
import { automateTwilioFlexCustomFieldsFillUpAr } from './automate-twilio-flex-custom-fields-fill-up';
import { automateOpenCustomFieldsFillUpAr } from './automate-open-custom-fields-fill-up';
import { automateFollowingUpWithACustomerUsingVoiceCallsAr } from './automate-following-up-with-a-customer-using-voice-calls';
import { automateSlackAlertsBasedOnTheCustomerIssueOrReportAr } from './automate-slack-alerts-based-on-the-customer-issue-or-report';
import { automateSkillBasedRoutingAr } from './automate-skill-based-routing';
import { automateTicketPrioritizationBasedOnItsContentAr } from './automate-ticket-prioritization-based-on-its-content';
import { automateTicketSentimentAnalysisAr } from './automate-ticket-sentiment-analysis';
import { automateReplyingToTrustpilotReviewsAr } from './automate-replying-to-trustpilot-reviews';
import { automateRequestingReviewOnlyWhenTheCustomerIsHappyAr } from './automate-requesting-review-only-when-the-customer-is-happy';
import { automateEscalatingToTheRightTeamAr } from './automate-escalating-to-the-right-team';
import { automatePhoneCallingFromEmailAr } from './automate-phone-calling-from-email';
import { automatePreSalesQualificationAr } from './automate-pre-sales-qualification';
import { aiPhoneCallsForAppointmentRemindersAr } from './ai-phone-calls-for-appointment-reminders';
import { aiPhoneCallsForPaymentCollectionAr } from './ai-phone-calls-for-payment-collection';
import { aiPhoneCallsForDeliveryNotificationsAr } from './ai-phone-calls-for-delivery-notifications';
import { aiPhoneCallsForCustomerSurveysAr } from './ai-phone-calls-for-customer-surveys';
import { aiPhoneCallsForRenewalRemindersAr } from './ai-phone-calls-for-renewal-reminders';
import { aiPhoneCallsForWinBackCampaignsAr } from './ai-phone-calls-for-win-back-campaigns';
import { aiPhoneCallsForOrderConfirmationsAr } from './ai-phone-calls-for-order-confirmations';
import { aiPhoneCallsForProactiveOutreachCampaignsAr } from './ai-phone-calls-for-proactive-outreach-campaigns';
import { detectChurnRiskProactiveRetentionCallAr } from './detect-churn-risk-proactive-retention-call';
import { identifyHighValueLeadPrioritySalesRoutingAr } from './identify-high-value-lead-priority-sales-routing';
import { detectExpansionOpportunityAccountGrowthCallAr } from './detect-expansion-opportunity-account-growth-call';
import { identifyPaymentFailureRecoveryCallAr } from './identify-payment-failure-recovery-call';
import { detectUsageMilestoneUpgradeTriggerAr } from './detect-usage-milestone-upgrade-trigger';
import { identifyReferralOpportunityRequestReferralAr } from './identify-referral-opportunity-request-referral';
import { detectCompetitorEvaluationCompetitiveWinCampaignAr } from './detect-competitor-evaluation-competitive-win-campaign';
import { identifyFreeTrialEndingConversionCallAr } from './identify-free-trial-ending-conversion-call';
import { detectBulkPurchaseIntentEnterpriseSalesHandoffAr } from './detect-bulk-purchase-intent-enterprise-sales-handoff';
import { identifyFeatureGapProductLedUpsellAr } from './identify-feature-gap-product-led-upsell';
import { automateCustomerEmailRepliesWithAiAr } from './automate-customer-email-replies-with-ai';
import { aiChatbotTemplateStarterAr } from './ai-chatbot-template-starter';
import { automateZendeskMacrosWithAiAr } from './automate-zendesk-macros-with-ai';
import { automateVoicemailTranscriptionAndCallbackWithAiAr } from './automate-voicemail-transcription-and-callback-with-ai';
import { automateLanguageDetectionOnTicketsWithAiAr } from './automate-language-detection-on-tickets-with-ai';
import { automatePiiRedactionOnTicketsWithAiAr } from './automate-pii-redaction-on-tickets-with-ai';
import { automateTicketTaggingAndLabelingWithAiAr } from './automate-ticket-tagging-and-labeling-with-ai';

/**
 * Arabic copy for the workflow-template detail pages, keyed by slug.
 *
 * Records are `Partial`, so anything omitted here falls back to the English
 * record field by field. Add a new template by creating
 * `src/lib/templates/ar/<slug>.ts` and registering it below.
 */
export const TEMPLATES_AR: Record<string, TemplateAr> = {
  'automate-support-tickets-quality-assurance':
    automateSupportTicketsQualityAssuranceAr,
  'automate-up-sells-from-support-tickets': automateUpSellsFromSupportTicketsAr,
  'automate-cart-recovery': automateCartRecoveryAr,
  'automate-zendesk-custom-fields-fill-up': automateZendeskCustomFieldsFillUpAr,
  'automate-hubspot-custom-fields-fill-up': automateHubspotCustomFieldsFillUpAr,
  'automate-salesforce-custom-fields-fill-up':
    automateSalesforceCustomFieldsFillUpAr,
  'automate-intercom-custom-fields-fill-up':
    automateIntercomCustomFieldsFillUpAr,
  'automate-freshdesk-custom-fields-fill-up':
    automateFreshdeskCustomFieldsFillUpAr,
  'automate-twilio-flex-custom-fields-fill-up':
    automateTwilioFlexCustomFieldsFillUpAr,
  'automate-open-custom-fields-fill-up': automateOpenCustomFieldsFillUpAr,
  'automate-following-up-with-a-customer-using-voice-calls':
    automateFollowingUpWithACustomerUsingVoiceCallsAr,
  'automate-slack-alerts-based-on-the-customer-issue-or-report':
    automateSlackAlertsBasedOnTheCustomerIssueOrReportAr,
  'automate-skill-based-routing': automateSkillBasedRoutingAr,
  'automate-ticket-prioritization-based-on-its-content':
    automateTicketPrioritizationBasedOnItsContentAr,
  'automate-ticket-sentiment-analysis': automateTicketSentimentAnalysisAr,
  'automate-replying-to-trustpilot-reviews':
    automateReplyingToTrustpilotReviewsAr,
  'automate-requesting-review-only-when-the-customer-is-happy':
    automateRequestingReviewOnlyWhenTheCustomerIsHappyAr,
  'automate-escalating-to-the-right-team': automateEscalatingToTheRightTeamAr,
  'automate-phone-calling-from-email': automatePhoneCallingFromEmailAr,
  'automate-pre-sales-qualification': automatePreSalesQualificationAr,
  'ai-phone-calls-for-appointment-reminders':
    aiPhoneCallsForAppointmentRemindersAr,
  'ai-phone-calls-for-payment-collection': aiPhoneCallsForPaymentCollectionAr,
  'ai-phone-calls-for-delivery-notifications':
    aiPhoneCallsForDeliveryNotificationsAr,
  'ai-phone-calls-for-customer-surveys': aiPhoneCallsForCustomerSurveysAr,
  'ai-phone-calls-for-renewal-reminders': aiPhoneCallsForRenewalRemindersAr,
  'ai-phone-calls-for-win-back-campaigns': aiPhoneCallsForWinBackCampaignsAr,
  'ai-phone-calls-for-order-confirmations': aiPhoneCallsForOrderConfirmationsAr,
  'ai-phone-calls-for-proactive-outreach-campaigns':
    aiPhoneCallsForProactiveOutreachCampaignsAr,
  'detect-churn-risk-proactive-retention-call':
    detectChurnRiskProactiveRetentionCallAr,
  'identify-high-value-lead-priority-sales-routing':
    identifyHighValueLeadPrioritySalesRoutingAr,
  'detect-expansion-opportunity-account-growth-call':
    detectExpansionOpportunityAccountGrowthCallAr,
  'identify-payment-failure-recovery-call':
    identifyPaymentFailureRecoveryCallAr,
  'detect-usage-milestone-upgrade-trigger':
    detectUsageMilestoneUpgradeTriggerAr,
  'identify-referral-opportunity-request-referral':
    identifyReferralOpportunityRequestReferralAr,
  'detect-competitor-evaluation-competitive-win-campaign':
    detectCompetitorEvaluationCompetitiveWinCampaignAr,
  'identify-free-trial-ending-conversion-call':
    identifyFreeTrialEndingConversionCallAr,
  'detect-bulk-purchase-intent-enterprise-sales-handoff':
    detectBulkPurchaseIntentEnterpriseSalesHandoffAr,
  'identify-feature-gap-product-led-upsell':
    identifyFeatureGapProductLedUpsellAr,
  'automate-customer-email-replies-with-ai':
    automateCustomerEmailRepliesWithAiAr,
  'ai-chatbot-template-starter': aiChatbotTemplateStarterAr,
  'automate-zendesk-macros-with-ai': automateZendeskMacrosWithAiAr,
  'automate-voicemail-transcription-and-callback-with-ai':
    automateVoicemailTranscriptionAndCallbackWithAiAr,
  'automate-language-detection-on-tickets-with-ai':
    automateLanguageDetectionOnTicketsWithAiAr,
  'automate-pii-redaction-on-tickets-with-ai':
    automatePiiRedactionOnTicketsWithAiAr,
  'automate-ticket-tagging-and-labeling-with-ai':
    automateTicketTaggingAndLabelingWithAiAr,
};

/**
 * A template record with its reader-facing copy in `locale`.
 *
 * Spreads the Arabic record over the English one so a missing or half-authored
 * record still renders rather than showing blanks.
 */
export function localizeTemplate(template: Template, locale: string): Template {
  if (locale !== 'ar') return template;

  const ar = TEMPLATES_AR[template.slug];
  return ar ? { ...template, ...ar } : template;
}
